
import { Component, Prop, Vue } from '~/utility/pu-class-decorator'
import { FavouriteMachineInterpreter } from '../favourite.machine'
import {
  getFavouritesMachine,
  FavouritesMachineInterpreter,
} from '../favourites.machine'

@Component
export default class CampsiteFavouriteButton extends Vue {
  @Prop({ required: true })
    campsiteId!: string

  @Prop()
    campsiteName: string

  favouritesMachine: FavouritesMachineInterpreter | null = null

  machine: FavouriteMachineInterpreter | null = null

  get isFavourite(): boolean {
    return !!this.machine?.state.matches('showingFavourite')
  }

  mounted() {
    this.favouritesMachine = getFavouritesMachine(this.$i18n.locale)
    this.favouritesMachine.send({
      type: 'GET_BUTTON',
      id: this.campsiteId,
    })
    this.favouritesMachine.onTransition(this.favouriteChangeListener)
  }

  destroyed() {
    if (this.favouritesMachine) {
      this.favouritesMachine.send({
        type: 'REMOVE_BUTTON',
        id: this.campsiteId,
      })
    }
  }

  private favouriteChangeListener(
    state: FavouritesMachineInterpreter['state'],
  ) {
    if (!this.machine && state.context.activeFavourites[this.campsiteId]) {
      const favourite = state.context.activeFavourites[this.campsiteId]
      if (favourite) this.machine = favourite.ref
    }
  }

  switchFavourite() {
    if (this.isFavourite) {
      this.removeFavourite()
    } else {
      this.addFavourite()
    }
  }

  addFavourite() {
    if (this.machine) {
      this.machine.send({ type: 'ADD', id: this.campsiteId })
      this.showInfoMessage('ADD')
    }
  }

  removeFavourite() {
    if (this.machine) {
      this.machine.send({
        type: 'REMOVE',
        id: this.campsiteId,
      })
      this.showInfoMessage('REMOVE')
    }
  }

  showInfoMessage(msg: 'ADD' | 'REMOVE') {
    const message =
      msg === 'ADD'
        ? this.$i18n.t('{campsiteName} has been added to your favourites', {
          campsiteName: this.campsiteName,
        })
        : this.$i18n.t('{campsiteName} has been removed from your favourites', {
          campsiteName: this.campsiteName,
        })
    this.$getSnackbar().then((snack) => {
      snack.show({ text: message })
    })
  }
}
